module.exports = __webpack_public_path__ + "static/triangle-grey-8fc43fdb6f58fe93b4421b1f9c7d6827.svg";